import { render, staticRenderFns } from "./time-range-widget.vue?vue&type=template&id=65973d9c&scoped=true&"
import script from "./time-range-widget.vue?vue&type=script&lang=js&"
export * from "./time-range-widget.vue?vue&type=script&lang=js&"
import style0 from "./time-range-widget.vue?vue&type=style&index=0&id=65973d9c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65973d9c",
  null
  
)

export default component.exports